import { FILTER_PREFIX, FILTER_SEPARATOR } from 'app/constants/BibConstants';
import { FIELD_ID } from 'app/constants/BrowseConstants';

const QUERY_PARAM_KEY = {
  INCLUDE_ALL_LANGUAGES: 'include_translations',
  PAGE: 'page',
  SCOPE: 'searchScope'
};

const serializeFieldId = fieldId => {
  if (fieldId === FIELD_ID.SCOPE) {
    return QUERY_PARAM_KEY.SCOPE;
  }

  return FILTER_PREFIX.concat(fieldId.toUpperCase());
};

const deserializeQuerystring = (querystring, { includedFieldIds, searchScopes }) => {
  const urlSearchParams = new URLSearchParams(querystring);

  const page = urlSearchParams.get(QUERY_PARAM_KEY.PAGE);

  const appliedFilterIdsByFieldId = includedFieldIds.reduce((acc, fieldId) => {
    const serializedFieldId = serializeFieldId(fieldId);

    const value = urlSearchParams.get(serializedFieldId);

    if (fieldId === FIELD_ID.SCOPE) {
      const isValidScope = searchScopes.some(searchScope => searchScope.scopeId === value);

      if (isValidScope) {
        acc[fieldId] = [value];
      } else {
        const defaultSearchScope = searchScopes.find(searchScope => searchScope.isDefault);

        acc[fieldId] = defaultSearchScope ? [defaultSearchScope.scopeId] : null;
      }

      return acc;
    } if (value) {
      acc[fieldId] = value.split(FILTER_SEPARATOR);
    } else {
      acc[fieldId] = [];
    }

    return acc;
  }, {});

  return {
    appliedFilterIdsByFieldId,
    isIncludeAllLanguages: false, // this value isn't persisted in the querystring on the search page
    page
  };
};

const serializeQuerystring = (queryState, { includedFieldIds, searchScopes }) => {
  const { appliedFilterIdsByFieldId, page } = queryState;

  const urlSearchParams = new URLSearchParams();

  Object.entries(appliedFilterIdsByFieldId).forEach(([fieldId, filterIds]) => {
    if (!filterIds.length) {
      return;
    }

    if (fieldId === FIELD_ID.SCOPE) {
      return;
    }

    const serializedFieldId = serializeFieldId(fieldId);
    const serializedValue = filterIds.join(FILTER_SEPARATOR);

    urlSearchParams.set(serializedFieldId, serializedValue);
  });

  if (page > 1) {
    urlSearchParams.set('page', page);
  }

  if (includedFieldIds.includes(FIELD_ID.SCOPE)) {
    const scopeId = appliedFilterIdsByFieldId[FIELD_ID.SCOPE]?.[0];
    const searchScope = searchScopes.find(nextSearchScope => nextSearchScope.scopeId === scopeId);

    if (searchScope && !searchScope.isDefault) {
      urlSearchParams.set(QUERY_PARAM_KEY.SCOPE, searchScope.scopeId);
    }
  }

  return urlSearchParams.toString();
};

export { deserializeQuerystring, serializeFieldId, serializeQuerystring };
